import {
  ApiButton,
  ContentTemplate,
  Divider,
  HeaderTemplate,
  KeyValue,
  SectionHeader,
  Typography,
} from 'web-library';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory, useParams} from 'react-router-dom';
import {
  useGetExamLevelByCode,
  usePostCreateWithdrawal,
} from '../../../../api/candidate/exam/@coordinator/queries-services/queries';
import RouteKey from '../../../../routes/key';
import {ExamType} from '../../../../api/candidate/exam/model';
import GceInstruction from './GceInstruction';
import PsleInstruction from './PsleInstruction';
import IpsleInstruction from './IpsleInstruction';
import {parseLocationSearch} from '../../../../utils/StringUtils';
import {AxiosError} from 'axios';
import {makeStyles} from 'tss-react/mui';
import {useWOGAA} from '../../../../hooks/wogaa';

const {withdrawal} = RouteKey.child;
const {withdrawal: withdrawalRoute, reason} = RouteKey.withdrawal.child;
const useStyles = makeStyles()((theme) =>
    ({
      errorText: {
        color: theme.color.state.stateError,
      }
    }));

const Instruction = () => {
  const {t} = useTranslation();
  const history = useHistory();
  const {examTypeCode} = useParams<{ examTypeCode: string }>();

  const {data: examLevel} = useGetExamLevelByCode(examTypeCode);

  const [errorMessage, setErrorMessage] = useState<string>('');
  const {classes} = useStyles();
  const postCreateWithdrawal = usePostCreateWithdrawal((res) => {
        history.push(`/${withdrawal}/${withdrawalRoute.route}/${res.data.uuid}/${reason.route}`);
      },
      (error) => {
        const axiosError = error as AxiosError<any>;
        const code = axiosError.response?.data?.code;

        if (code === '1014' || code === '1013' || code === '1019') {
          // @ts-ignore
          setErrorMessage(axiosError.response?.data?.message!);
        }
      });


  const {token = ''} = parseLocationSearch(location.search);
// wogaa tracking for coordinator exam registration start withdrawal //
  const {transactionStart} = useWOGAA('myexamsseab-6456');

  const renderInstructionWithdrawal = () => {
    switch (examTypeCode) {
      case ExamType.GCE:
        return <GceInstruction/>;
      case ExamType.IPSLE:
        return <IpsleInstruction/>;
      default:
        return <PsleInstruction/>;
    }
  };

  return (
      <>
        <HeaderTemplate>
          <KeyValue
              keyText={t('withdrawal->>Coordinator.Header.ExamLevel')}
              valueText={examLevel?.examType}
          />
        </HeaderTemplate>
        <ContentTemplate type="full">
          <SectionHeader title={t('withdrawal->>Coordinator.Instruction.SectionHeader1')}/>

          <Typography variant="h3">{t('withdrawal->>Coordinator.Instruction.Subtitle')}</Typography>

          {renderInstructionWithdrawal()}

          <Divider paddingTop/>

          <SectionHeader title={t('withdrawal->>Coordinator.Instruction.SectionHeader2')}/>

          <ApiButton
              id="button-start-withdrawal-application"
              variant="contained"
              status={postCreateWithdrawal.status}
              onClick={() => {
                transactionStart();
                postCreateWithdrawal.mutate({examType: examTypeCode, token: token});
              }}
          >
            {t('withdrawal->>Coordinator.Instruction.StartApplication')}
          </ApiButton>
          {errorMessage && (
              <Typography className={classes.errorText} variant="body2">
                {errorMessage}
              </Typography>
          )}
        </ContentTemplate>
      </>
  );
};

export default Instruction;
